import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../StateContext/Application";
import {
  Form,
  Link,
  redirect,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { apiurl } from "../../../../path";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../styles/GooglePagination";
import { formatDateTime, formatDate } from "../../../../utils/DateFormat";
const GRPendingList = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const context = useContext(AdminContext);
  const { getGRNPendingList } = context;
  const [project, setProjectList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(() => {
    const page = searchParams.get("page");
    return page ? parseInt(page) : 1;
  });

  const billsPerPage = 10;
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;

  const sortedBills = Array.isArray(filteredBills)
    ? filteredBills
        .slice() // ✅ prevent state mutation
        .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    : [];
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);

  const handlePageChange = (newPage) => {
    // const validpage = math
    setCurrentPage(newPage);
    setSearchParams({ page: newPage });
  };
  const getProjectList = async () => {
    let data = await getGRNPendingList("", "");
    // let data = await getGRNPendingList("", "")
    console.log("data", data);
    setProjectList(data);
    setFilteredBills(data);
  };

  useEffect(() => {
    sessionStorage.removeItem("createTechnicalForm");
    getProjectList();
  }, []);

  let projectList = [];
  if (project.length > 0) {
    projectList = project;
  }

  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = project.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
  }, [searchTerm, project]);

  useEffect(() => {
    const page = parseInt(searchParams.get("page")) || 1;

    // If page is greater than total pages, set to last page
    if (totalPages > 0 && page > totalPages) {
      setCurrentPage(totalPages);
      setSearchParams({ page: totalPages });
    } else if (page < 1) {
      // If page is less than 1, set to first page
      setCurrentPage(1);
      setSearchParams({ page: 1 });
    }
  }, [totalPages, searchParams, setSearchParams]);

  return (
    <>
      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          height: "89vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="col-11 m-auto">
          <div className="col-12">
            <div
              className="col-12 px-4 mb-4 mt-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
              <h5 className="my-auto fw-bold">
                <img
                  src="/GR-Approval64.png"
                  alt="Vendor Report"
                  style={{ width: "24px", height: "24px" }}
                  className="my-auto me-1"
                />
                <span className="my-auto">{t("GR Approved List")}</span>
              </h5>
              {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm}
                            style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}
              <div
                style={{
                  position: "relative",
                  width: "250px",
                  marginRight: "10px",
                }}
              >
                <img
                  src="/Search32.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    width: "16px",
                    height: "16px",
                    opacity: 0.6,
                  }}
                />
                <input
                  type="text"
                  placeholder={t("Search Here")}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                  style={{
                    width: "100%",
                    padding: "8px 12px 8px 32px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    backgroundColor: "#f1f6fc",
                    fontSize: "14px",
                    color: "#333",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                    outline: "none",
                  }}
                />
              </div>
            </div>
            <div className="col-12 pb-5">
              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  boxShadow: "0px 0px 5px 1px #E4E8EC",
                  borderRadius: "20px",
                  width: "100%",
                  maxWidth: "100%",
                  overflowX: "hidden",
                }}
              >
                <div
                  className="col-12 tableDesign"
                  style={{ background: "#2C78DB", overflowX: "scroll" }}
                >
                  <table
                    className="m-0 p-0"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                        }}
                      >
                        <th style={{ minWidth: "60px", padding: "8px" }}>
                          {t("Sr.No.")}
                        </th>
                        <th style={{ minWidth: "180px", padding: "8px" }}>
                          {t("Action")}
                        </th>
                        {/* <th style={{ minWidth: "100px", padding: "8px" }}>GRID</th> */}
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("HeadCode")}
                        </th>
                        <th style={{ minWidth: "100px", padding: "8px" }}>
                          {t("Work Name")}
                        </th>
                        <th style={{ minWidth: "100px", padding: "8px" }}>
                          {t("Job ID")}
                        </th>
                        <th style={{ minWidth: "100px", padding: "8px" }}>
                          {t("Approved Year")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Zilla Parishad")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Taluka")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Gram Panchayat")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Approved Amount")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("GR Number")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("GR Date")}
                        </th>
                        <th style={{ minWidth: "200px", padding: "8px" }}>
                          {t("GR Copy")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("GR Approval Copy")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Creation Date")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentBills?.length === 0 ? (
                        <tr>
                          <td
                            colSpan="20"
                            style={{
                              textAlign: "center",
                              padding: "10px",
                              backgroundColor: "#f9f9f9",
                            }}
                          >
                            {t("No data available")}
                          </td>
                        </tr>
                      ) : (
                        currentBills?.map((project, index) => {
                          const bgColor =
                            index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                          return (
                            <tr
                              key={index}
                              style={{
                                backgroundColor: bgColor,
                                fontSize: "18px",
                                fontWeight: "500",
                              }}
                            >
                              <td style={{ padding: "8px" }}>
                                {(currentPage - 1) * billsPerPage + index + 1}
                              </td>
                              <td style={{ padding: "8px" }}>
                                <Link
                                  to={`/AdminDashboard/TechnicalSanction/${project.ProposalID}?returnPage=${currentPage}`}
                                  style={{
                                    color: "red",
                                    textDecoration: "none",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {" "}
                                  Create Technical Sanction{" "}
                                </Link>
                              </td>
                              {/* <td style={{ padding: "8px" }}> {project.GRID}</td> */}
                              <td style={{ padding: "8px" }}>
                                {project.HeadCode}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {project.Work_name}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {project.JOB_ID}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {project.ProposalYear}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {project.ZillaParishad}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {project.Taluka}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {project.Gram_panchayat}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {project.ProposalAmount}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {project.GRNumber}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {formatDate(project.GRDate)}
                                {/* {project.GRDate?.split("T")[0]} */}
                              </td>
                                                   <td style={{ padding: '8px' }}>
                              {project.GRUploadFile || project.GRCopy ? (
                                <>
                                  {project.GRUploadFile && (
                                    <div>
                                      <a
                                        href={`${apiurl}/ProposalFile/${project.GRUploadFile}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {project.GRUploadFile}
                                      </a>
                                    </div>
                                  )}
                            
                                  {project.GRCopy && (
                                    <div>
                                      <a
                                        href={`${apiurl}/ProjectDocsImages/${project.GRCopy}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {project.GRCopy}
                                      </a>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <p className="text-danger my-auto fw-bold">
                                  {t("No File")}
                                </p>
                              )}
                            </td>
                                                          <td style={{ padding: "8px" }}>
                                                            {project.GRDraftCopy ? (
                                                              <a
                                                                href={`${apiurl}/GRDraftCopy/${project.GRDraftCopy}`}
                                                                target="_blank"
                                                              >
                                                                {project.GRDraftCopy}{" "}
                                                              </a>
                                                            ) : (
                                                              <p className="fw-bold text-danger my-auto">
                                                                {t("No File")}
                                                              </p>
                                                            )}
                                                          </td>
                              {/* <td style={{ padding: "8px" }}>
                                {new Date(project.Date).toLocaleString()}
                              </td> */}
                              <td style={{ padding: "8px" }}>{formatDateTime(project.Date)} </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="col-12 mt-4">
                  <div className="row">
                    <div className="col-6">
                      <p className="text-gray-600" style={{ fontSize: "18px" }}>
                        {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                        {Math.min(indexOfLastBill, filteredBills.length)}{" "}
                        {t("of")} {project.length} {t("entries")}
                      </p>
                    </div>
                    <div
                      className="col-6"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                      }}
                    >
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GRPendingList;
